import { render } from "./GlobalAlert.vue?vue&type=template&id=1aea260e"
import script from "./GlobalAlert.vue?vue&type=script&lang=js"
export * from "./GlobalAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__